import React from 'react';

interface CheckIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

export const CheckIcon: React.FC<CheckIconProps> = ({
  width = 34,
  height = 34,
  fill = '#721C34',
  className,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14.5413 24.25L26.333 12.4583L24.4163 10.5833L14.5413 20.4583L9.54134 15.4583L7.66634 17.3333L14.5413 24.25ZM16.9997 33.3333C14.7219 33.3333 12.5691 32.8958 10.5413 32.0208C8.51356 31.1458 6.74273 29.9514 5.22884 28.4375C3.71495 26.9236 2.52051 25.1528 1.64551 23.125C0.770508 21.0972 0.333008 18.9444 0.333008 16.6667C0.333008 14.3611 0.770508 12.1944 1.64551 10.1667C2.52051 8.13889 3.71495 6.375 5.22884 4.875C6.74273 3.375 8.51356 2.1875 10.5413 1.3125C12.5691 0.4375 14.7219 0 16.9997 0C19.3052 0 21.4719 0.4375 23.4997 1.3125C25.5275 2.1875 27.2913 3.375 28.7913 4.875C30.2913 6.375 31.4788 8.13889 32.3538 10.1667C33.2288 12.1944 33.6663 14.3611 33.6663 16.6667C33.6663 18.9444 33.2288 21.0972 32.3538 23.125C31.4788 25.1528 30.2913 26.9236 28.7913 28.4375C27.2913 29.9514 25.5275 31.1458 23.4997 32.0208C21.4719 32.8958 19.3052 33.3333 16.9997 33.3333ZM16.9997 30.8333C20.9441 30.8333 24.2913 29.4514 27.0413 26.6875C29.7913 23.9236 31.1663 20.5833 31.1663 16.6667C31.1663 12.7222 29.7913 9.375 27.0413 6.625C24.2913 3.875 20.9441 2.5 16.9997 2.5C13.083 2.5 9.74273 3.875 6.97884 6.625C4.21495 9.375 2.83301 12.7222 2.83301 16.6667C2.83301 20.5833 4.21495 23.9236 6.97884 26.6875C9.74273 29.4514 13.083 30.8333 16.9997 30.8333Z"
        fill={fill}
      />
    </svg>
  );
};
